"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _taggedTemplateLiteralLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteralLoose"));

var _classnames = _interopRequireDefault(require("classnames"));

var _colors = require("HubStyleTokens/colors");

var _sizes = require("HubStyleTokens/sizes");

var _I18n = _interopRequireDefault(require("I18n"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireWildcard(require("react"));

var _emptyFunction = _interopRequireDefault(require("react-utils/emptyFunction"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _UIIconHolder = _interopRequireDefault(require("../icon/UIIconHolder"));

var _BrowserTest = require("../utils/BrowserTest");

var _lazyEval = _interopRequireDefault(require("../utils/lazyEval"));

var _memoWithDisplayName = _interopRequireDefault(require("../utils/memoWithDisplayName"));

var _createLazyPropType = _interopRequireDefault(require("../utils/propTypes/createLazyPropType"));

var _tshirtSize = require("../utils/propTypes/tshirtSize");

var _LoadingConstants = require("./LoadingConstants");

function _templateObject10() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n  animation: ", " 2s cubic-bezier(0.42, 0, 0.58, 1) infinite,\n    ", " 2s linear infinite;\n  stroke-dasharray: none;\n  stroke-dashoffset: 0;\n  stroke-linecap: round;\n  transform-origin: center;\n  ", "\n"]);

  _templateObject10 = function _templateObject10() {
    return data;
  };

  return data;
}

function _templateObject9() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n  display: block;\n  max-width: 100%;\n"]);

  _templateObject9 = function _templateObject9() {
    return data;
  };

  return data;
}

function _templateObject8() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n      animation: ", " 2s linear infinite;\n    "]);

  _templateObject8 = function _templateObject8() {
    return data;
  };

  return data;
}

function _templateObject7() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n  opacity: 1;\n  transition: opacity 0.2s cubic-bezier(0.42, 0, 0.58, 1),\n    transform 0.2s cubic-bezier(0.89, 0.03, 0.68, 0.22);\n  ", "\n\n  ", "\n"]);

  _templateObject7 = function _templateObject7() {
    return data;
  };

  return data;
}

function _templateObject6() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n  align-items: center;\n  display: flex;\n  justify-content: center;\n  opacity: 0;\n  position: absolute;\n  transform: scale(0.7);\n  transition: opacity 0.2s cubic-bezier(0.42, 0, 0.58, 1) 0.1s,\n    transform 0.3s cubic-bezier(0.2, 0.9, 0.3, 2) 0.1s;\n  ", "\n"]);

  _templateObject6 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n  margin-top: ", ";\n\n  &:not(:empty) {\n    margin-left: ", ";\n    margin-right: ", ";\n  }\n"]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n  align-items: center;\n  display: flex;\n  height: ", ";\n  justify-content: center;\n  width: ", ";\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n  position: relative;\n  align-items: center;\n  color: ", ";\n  display: flex;\n  flex-direction: ", ";\n  justify-content: ", ";\n  ", ";\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n  0% {\n    stroke-dasharray: 1, 150;\n    stroke-dashoffset: 0;\n  }\n  50% {\n    stroke-dasharray: 90, 150;\n    stroke-dashoffset: -50;\n  }\n  100% {\n    stroke-dasharray: 90, 150;\n    stroke-dashoffset: -140;\n  }\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n  100% {\n    transform: rotate(360deg)\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var getSpinnerSize = function getSpinnerSize(sizeName) {
  return _LoadingConstants.SIZE_OPTIONS[sizeName] || _LoadingConstants.SIZE_OPTIONS['sm'];
};

var privateSpin = (0, _styledComponents.keyframes)(_templateObject());
var privateDash = (0, _styledComponents.keyframes)(_templateObject2());

var SpinnerOuter = _styledComponents.default.div.withConfig({
  displayName: "UILoadingSpinner__SpinnerOuter",
  componentId: "sc-17cuir7-0"
})(_templateObject3(), function (props) {
  return props.use === 'on-dark' ? _colors.OLAF : 'currentColor';
}, function (props) {
  return props.layout === 'centered' && 'column';
}, function (props) {
  return props.layout === 'centered' && 'center';
}, function (props) {
  return props.grow ? "width: 100%; height: 100%;" : 'margin: 8px';
});

var SpinnerInner = _styledComponents.default.div.withConfig({
  displayName: "UILoadingSpinner__SpinnerInner",
  componentId: "sc-17cuir7-1"
})(_templateObject4(), function (props) {
  return getSpinnerSize(props.size);
}, function (props) {
  return getSpinnerSize(props.size);
});

var SpinnerLabel = _styledComponents.default.span.withConfig({
  displayName: "UILoadingSpinner__SpinnerLabel",
  componentId: "sc-17cuir7-2"
})(_templateObject5(), function (props) {
  return props.layout === 'centered' && _sizes.BASE_ICON_SPACING_X;
}, _sizes.BASE_ICON_SPACING_X, _sizes.BASE_ICON_SPACING_X);

var ResultSpinner = _styledComponents.default.div.withConfig({
  displayName: "UILoadingSpinner__ResultSpinner",
  componentId: "sc-17cuir7-3"
})(_templateObject6(), function (_ref) {
  var showResult = _ref.showResult;
  return showResult && "opacity: 1;\n    position: relative;\n    transform: scale(1);\n  ";
});

var SpinnerWrapper = _styledComponents.default.div.withConfig({
  displayName: "UILoadingSpinner__SpinnerWrapper",
  componentId: "sc-17cuir7-4"
})(_templateObject7(), (0, _BrowserTest.isIE11)() && (0, _styledComponents.css)(_templateObject8(), privateSpin), function (_ref2) {
  var showResult = _ref2.showResult;
  return showResult && "margin-left: -1px;\n    opacity: 0;\n    transform: scale(.7);\n    width: 1px;\n  ";
});

var Ring = _styledComponents.default.svg.withConfig({
  displayName: "UILoadingSpinner__Ring",
  componentId: "sc-17cuir7-5"
})(_templateObject9());

var RingPath = _styledComponents.default.circle.withConfig({
  displayName: "UILoadingSpinner__RingPath",
  componentId: "sc-17cuir7-6"
})(_templateObject10(), privateDash, privateSpin, (0, _BrowserTest.isIE11)() && "stroke-dasharray: 50, 150;");

var getComputedStyle = function getComputedStyle(style, grow, minHeight) {
  if (minHeight) {
    var computedStyle = (0, _extends2.default)({}, style, {
      minHeight: minHeight
    });
    if (!grow) computedStyle.height = '1rem';
    return computedStyle;
  }

  return style;
};

var resultIconStyles = {
  lineHeight: 'inherit',
  verticalAlign: 'middle'
};
var UILoadingSpinner = (0, _memoWithDisplayName.default)('UILoadingSpinner', function (props) {
  var dataLoading = props['data-loading'],
      className = props.className,
      failed = props.failed,
      grow = props.grow,
      label = props.label,
      labelCompletedText = props.labelCompletedText,
      layout = props.layout,
      minHeight = props.minHeight,
      onResultDisplayFinish = props.onResultDisplayFinish,
      resultAnimationDuration = props.resultAnimationDuration,
      resultIcon = props.resultIcon,
      showLabel = props.showLabel,
      showResult = props.showResult,
      size = props.size,
      style = props.style,
      use = props.use,
      rest = (0, _objectWithoutProperties2.default)(props, ["data-loading", "className", "failed", "grow", "label", "labelCompletedText", "layout", "minHeight", "onResultDisplayFinish", "resultAnimationDuration", "resultIcon", "showLabel", "showResult", "size", "style", "use"]);
  var resultDisplayTimeoutRef = (0, _react.useRef)(null);
  (0, _react.useEffect)(function () {
    if (!showResult) return undefined;
    resultDisplayTimeoutRef.current = setTimeout(onResultDisplayFinish, resultAnimationDuration);
    return function () {
      clearTimeout(resultDisplayTimeoutRef.current);
    };
  }, [onResultDisplayFinish, resultAnimationDuration, showResult]);
  var computedLayout = layout || (grow ? 'centered' : 'inline');
  var computedLabelText = showResult && !failed ? (0, _lazyEval.default)(labelCompletedText) : (0, _lazyEval.default)(label);
  var RenderedLabel = showLabel ? SpinnerLabel : 'span';
  var renderedLabelProps = {
    children: computedLabelText
  };

  if (showLabel) {
    renderedLabelProps.layout = computedLayout;
  } else {
    renderedLabelProps.className = 'sr-only';
  }

  var shorthandSize = (0, _tshirtSize.toShorthandSize)(size);
  var spinnerSizePx = parseInt(getSpinnerSize(shorthandSize), 10);
  return _react.default.createElement(SpinnerOuter, (0, _extends2.default)({}, rest, {
    className: (0, _classnames.default)('private-spinner', className),
    style: getComputedStyle(style, grow, minHeight),
    "data-loading": dataLoading !== undefined ? dataLoading : !showResult,
    layout: computedLayout,
    grow: grow,
    use: use
  }), _react.default.createElement(SpinnerInner, {
    size: shorthandSize
  }, _react.default.createElement(SpinnerWrapper, {
    showResult: showResult
  }, _react.default.createElement(Ring, {
    height: spinnerSizePx,
    width: spinnerSizePx,
    viewBox: "0 0 50 50",
    stroke: _LoadingConstants.USE_COLORS[use]
  }, _react.default.createElement("circle", {
    cx: "25",
    cy: "25",
    r: "22.5",
    fill: "none",
    strokeWidth: "5"
  }), _react.default.createElement(RingPath, {
    cx: "25",
    cy: "25",
    r: "22.5",
    fill: "none",
    stroke: _LoadingConstants.USE_INDICATOR_COLORS[use],
    strokeWidth: "5"
  }))), resultIcon && !failed && _react.default.createElement(ResultSpinner, {
    showResult: showResult
  }, _react.default.createElement(_UIIconHolder.default, {
    innerStyles: resultIconStyles,
    name: resultIcon,
    color: _LoadingConstants.ICON_COLOR_MAP[use],
    size: _LoadingConstants.ICON_SIZE_MAP[shorthandSize] || _LoadingConstants.ICON_SIZE_MAP['sm']
  }))), _react.default.createElement(RenderedLabel, renderedLabelProps));
});
UILoadingSpinner.propTypes = {
  'data-loading': _propTypes.default.bool,
  failed: _propTypes.default.bool,
  showResult: _propTypes.default.bool,
  label: (0, _createLazyPropType.default)(_propTypes.default.node).isRequired,
  labelCompletedText: (0, _createLazyPropType.default)(_propTypes.default.node).isRequired,
  layout: _propTypes.default.oneOf(['inline', 'centered']),
  minHeight: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.string]),
  grow: _propTypes.default.bool,
  resultAnimationDuration: _propTypes.default.number.isRequired,
  resultIcon: _propTypes.default.string,
  use: _propTypes.default.oneOf(_LoadingConstants.USES),
  showLabel: _propTypes.default.bool.isRequired,
  size: (0, _tshirtSize.propTypeForSizes)(['xs', 'sm', 'md']),
  onResultDisplayFinish: _propTypes.default.func
};
UILoadingSpinner.defaultProps = {
  failed: false,
  grow: false,
  label: function label() {
    return _I18n.default.text('ui.UILoadingSpinner.busyText');
  },
  labelCompletedText: function labelCompletedText() {
    return _I18n.default.text('ui.UILoadingSpinner.completedText');
  },
  showResult: false,
  resultAnimationDuration: 1500,
  resultIcon: 'success',
  role: 'status',
  onResultDisplayFinish: _emptyFunction.default,
  showLabel: false,
  size: 'sm',
  use: 'link'
};
var _default = UILoadingSpinner;
exports.default = _default;
module.exports = exports.default;


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/UIComponents/static-2.3773/js/loading/UILoadingSpinner.js
// module id = 280
// module chunks = 0